
import React from "react";
import { Clock } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { TimeSlot } from "@/hooks/useMentorScheduleAvailability";
import { isTimeSlotInPast } from "@/services/mentorAvailabilityService";

interface TimeSlotSelectorProps {
  selectedDate: Date | undefined;
  timeSlots: TimeSlot[];
  selectedTimeSlot: TimeSlot | null;
  onTimeSlotSelect: (slot: TimeSlot) => void;
}

export const TimeSlotSelector: React.FC<TimeSlotSelectorProps> = ({
  selectedDate,
  timeSlots,
  selectedTimeSlot,
  onTimeSlotSelect,
}) => {
  if (!selectedDate) return null;

  return (
    <div>
      <div className="flex items-center mb-2">
        <Clock className="w-4 h-4 mr-2 text-[#00B6F0]" />
        <h3 className="text-sm font-medium">
          Horários disponíveis para {format(selectedDate, "dd 'de' MMMM", { locale: ptBR })}
        </h3>
      </div>
      
      {timeSlots.length > 0 ? (
        <div className="grid grid-cols-2 gap-2">
          {timeSlots.map((slot, index) => {
            // Converter formato TimeSlot (start/end) para formato esperado pela função (startTime/endTime)
            const isPast = isTimeSlotInPast(selectedDate, {
              startTime: slot.start,
              endTime: slot.end
            });
            
            return (
              <button
                key={index}
                disabled={isPast}
                className={`p-2 rounded-md border transition-all text-sm ${
                  isPast
                    ? "border-gray-600 bg-gray-800/50 text-gray-500 cursor-not-allowed opacity-50"
                    : selectedTimeSlot && selectedTimeSlot.start === slot.start 
                      ? "border-[#00B6F0] bg-[#00B6F0]/20 text-white" 
                      : "border-[#223342] bg-[#1A2233] text-gray-300 hover:border-[#00B6F0] hover:bg-[#1A2233]"
                }`}
                onClick={() => !isPast && onTimeSlotSelect(slot)}
                title={isPast ? "Este horário já passou" : undefined}
              >
                {slot.start} - {slot.end}
              </button>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-400 text-center py-4">
          Nenhum horário disponível para esta data
        </p>
      )}
    </div>
  );
};
